module.exports = __webpack_public_path__ + "img/bg_avatar_female_72.47c65010.png";